import api from '../token';

export const Login = async (payload) => {
  try {
    const response = await api.post('/login',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

